import { Fade, None, Slide, SlideDown } from './LayerAnimationTypes';
import PropTypes from 'prop-types';
export var Layers = {
  PopoverContent: 'POPOVER_CONTENT',
  Modal: 'MODAL',
  PopoverModal: 'POPOVER_MODAL'
};
export var OrderedLayers = [// Bottom layer
Layers.PopoverContent, Layers.Modal, Layers.PopoverModal];
export var LayerContextType = PropTypes.string;
export var AnimationTypes = {
  None: None,
  Slide: Slide,
  SlideDown: SlideDown,
  Fade: Fade,
  Custom: 'Custom'
};